const API_BASE = import.meta.env.VITE_API_BASE;

if (!API_BASE) {
  throw new Error('VITE_API_BASE is not set — the app cannot reach the Huaca API.');
}

export const config = {
  apiBase: API_BASE as string,
  /** This module's own origin — logins and invites return HERE, not to a central app. */
  webOrigin: window.location.origin,
  productId: 'claro',
  productName: 'Claro',
  /**
   * Where the PUBLIC client Room is served (the separate app built in Phase 4). The share link the
   * professional copies is `${roomBase}/#i=<instanceId>`. Set VITE_ROOM_BASE per environment.
   */
  roomBase: (import.meta.env.VITE_ROOM_BASE as string | undefined) ?? 'https://room.claro.huaca.io',
} as const;
